export const getLastDayOfMonthAfterXMonths = (
  d: Date,
  afterMonths = 12,
): Date => {
  let ano = d.getFullYear();
  let mes = d.getMonth();
  ano += Math.floor(mes / 12);
  mes %= 12;

  return new Date(ano, mes + afterMonths, 0);
};

export const getDayAfterXMonths = (d: Date, afterMonths = 12): Date => {
  let ano = d.getFullYear();
  let mes = d.getMonth();
  const dia = d.getDate();
  ano += Math.floor(mes / 12);
  mes %= 12;

  return new Date(ano, mes + afterMonths, dia);
};
